import React from 'react';
import analizeRideStatus from '../../utils/analizeRideStatus';
import { ReactComponent as Sending } from '../../assets/img/sending-small-icon.svg';
import { ReactComponent as ContactingDriver } from '../../assets/img/contacting-driver-small-icon.svg';
import { ReactComponent as AdditionalDriver } from '../../assets/img/additional-driver-small-icon.svg';
import { ReactComponent as HangIn } from '../../assets/img/hang-in-small-icon.svg';

const pathName = window.location.pathname;

const RideInfo = props => {
  const isTracker = pathName === '/tracker';
  const { ride, isGuestBooking } = props;
  const { rideStatusMessage, location, eta, state } = ride;
  const { key, title, etaMins, etaMessage, statusMessage, statusItem } = analizeRideStatus(state, eta, isTracker);

  const statusItemList = [
    {
      id: 1,
      icon: <Sending />,
      active: statusItem,
      isVisible: statusItem === 1,
    },
    {
      id: 2,
      icon: <ContactingDriver />,
      active: statusItem > 1,
      isVisible: statusItem === 2,
    },
    {
      id: 3,
      icon: <AdditionalDriver />,
      active: statusItem > 2,
      isVisible: statusItem === 3,
    },
    {
      id: 4,
      icon: <HangIn />,
      active: statusItem > 3,
      isVisible: statusItem === 4,
    },
  ];

  if (!title) return <></>;

  return (
    <div className="modal-context">
      <div className="status-container">
        <div className="status-message-container">
          <div>
            {title && <p className="container-label">{title}</p>}
            <p className="container-sub-label">{statusMessage}</p>

            {key === 'assignedRideState' && location && !isTracker && (
              <p className="container-sub-label">Your ride is on its way to {location}</p>
            )}
            {key === 'onsiteRideState' && location && !isTracker && (
              <p className="container-sub-label">Pickup at {location}</p>
            )}

            {isTracker && <p className="container-sub-label">{location}</p>}
          </div>
          {key === 'requestingRide' && (
            <div className="status-requested-icon">
              {statusItemList.map(item => (
                <span key={item.id} className={`status-image ${item.isVisible ? 'active' : ''}`}>
                  {item.icon}
                </span>
              ))}
            </div>
          )}
          {eta && (
            <div className="eta-container text-center">
              <p className="container-label">ETA</p>
              <p className="container-sub-label">{eta} Min</p>
            </div>
          )}
        </div>
        {key === 'requestingRide' && statusItem && (
          <div className="status-requested">
            {statusItemList.map(item => (
              <span
                key={item.id}
                className={`status-requested-item ${item.active ? 'active' : ''} ${item.isVisible ? 'blinked' : ''}`}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default RideInfo;
